import PropTypes from 'prop-types'
import { Button, Spinner } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import { useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { FormikCheckboxGroupItem } from '../../../../../components/FormikFields'
import SectionContentContainer from '../../../engage/modals/OnboardUserModal/common/SectionContentContainer'
import { FORM_FIELDS } from '../constants'
import LicenseAvailability from './LicenseAvailability/LicenseAvailability'

function Licenses({
  customerLicenses,
  isFetchingCustomerLicenses,
  errorFetchingCustomerLicenses,
  syncCustomerLicenses,
  isSyncingCustomerLicenses,
  isGws = false,
}) {
  const { setFieldTouched, errors, touched, values } = useFormikContext()

  useEffect(() => {
    setFieldTouched(FORM_FIELDS.LICENSES, true, true)
  }, [customerLicenses, setFieldTouched])

  return (
    <div className="section px-4 py-4">
      <Row className="mb-3">
        <Col sm="12">
          <div className="text-strong mb-2 d-flex align-items-baseline">
            <FormattedMessage id="ENGAGE.ONBOARD.LICENSE_ASSIGNMENT" />

            {!isGws && syncCustomerLicenses && (
              <Button
                variant="link"
                className="p-0 ms-2"
                onClick={syncCustomerLicenses}
                disabled={isSyncingCustomerLicenses || isFetchingCustomerLicenses}
              >
                <i className={clsx('fa fa-rotate', isSyncingCustomerLicenses && 'fa-spin')} />
              </Button>
            )}
          </div>

          {(() => {
            if (!isGws && isFetchingCustomerLicenses) {
              return (
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <Spinner size="small" />
                  <div className="mt-3 text-bold text-color-secondary">
                    <FormattedMessage id="ENGAGE.ONBOARD.LOADING_LICENSES" />
                  </div>
                </div>
              )
            }
            if (!isGws && errorFetchingCustomerLicenses) {
              return (
                <div className="d-flex justify-content-center text-bold text-color-secondary">
                  <FormattedMessage id="ENGAGE.ONBOARD.FAILED_TO_LOAD_LICENSES" />
                </div>
              )
            }
            if (!customerLicenses?.length) {
              return (
                <div className="d-flex justify-content-center text-bold text-color-secondary">
                  <FormattedMessage id="ENGAGE.ONBOARD.NO_LICENSES" />
                </div>
              )
            }
            return (
              <SectionContentContainer>
                {customerLicenses.map((license) => {
                  const isAssigned = values[FORM_FIELDS.LICENSES]?.includes(license.id)
                  const isUnavailable = !isGws && license.availableLicences <= 0 && !isAssigned

                  return (
                    <FormikCheckboxGroupItem
                      name={FORM_FIELDS.LICENSES}
                      id={license.id}
                      key={license.id}
                      disabled={isUnavailable}
                      className="checkbox-left-aligned"
                      label={
                        <div className="ms-2">
                          <span className="font-bolder">{license.displayName || license.id}</span>
                          <p className="font-color-2">
                            <LicenseAvailability license={license} isAssigned={isAssigned} isGws={isGws} />
                          </p>
                        </div>
                      }
                    />
                  )
                })}

                {errors[FORM_FIELDS.LICENSES] && touched[FORM_FIELDS.LICENSES] ? (
                  <div className="text-color-danger mb-3">{errors[FORM_FIELDS.LICENSES]}</div>
                ) : null}
              </SectionContentContainer>
            )
          })()}
        </Col>
      </Row>
    </div>
  )
}

Licenses.propTypes = {
  customerLicenses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      displayName: PropTypes.string,
      availableLicences: PropTypes.number,
      totalLicences: PropTypes.number,
    }),
  ),
  isFetchingCustomerLicenses: PropTypes.bool,
  errorFetchingCustomerLicenses: PropTypes.bool,
  syncCustomerLicenses: PropTypes.func,
  isSyncingCustomerLicenses: PropTypes.bool,
  isGws: PropTypes.bool,
}

export default Licenses
